// extracted by mini-css-extract-plugin
module.exports = {"Container":"Partner_Container__u8Zzq","item":"Partner_item__lCk_O"};